import { useMemo } from 'react';
import { parsePath, useHistory } from 'quartz-routing/react-router';
import { getAppName, isRecognizedAppName } from '../utils/app';
import { findACRouteForPath } from '../routes/academyRoutes';
const extractPathname = to => {
  if (typeof to === 'string') {
    return parsePath(to).pathname;
  }
  return to.pathname;
};
export const shouldReloadLocation = to => {
  const currentApp = getAppName();
  if (!isRecognizedAppName(currentApp)) {
    return false;
  }
  const pathname = extractPathname(to);
  if (!pathname) {
    return false;
  }
  const match = findACRouteForPath(pathname);
  if (!match) {
    return false;
  }
  return match.appName !== currentApp;
};
export const useShouldReloadLocation = to => {
  const history = useHistory();
  // eslint-disable-next-line react-hooks/immutability
  to = typeof to === 'function' ? to(history.location) : to;
  return useMemo(() => shouldReloadLocation(to), [to]);
};